import React from 'react';
import { useHookstate } from '@hookstate/core';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Navigation from './screens/navigation/Navigation';
import reduxStore from './utils/redux/store';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/theme.css';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const App = () => {
  const appState = useHookstate({
    loading: true,
    error: null,
  });
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Provider store={reduxStore.store}>
        <PersistGate loading={null} persistor={reduxStore.persistor}>
          <ThemeProvider>
            <BrowserRouter basename='/' window={window}>
              <Navigation appState={appState} />
            </BrowserRouter>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
};

export default App;
